/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Api_Reference_Envelope_HelpInputs */

const en_directory_api_reference_envelope_help = /** @type {(inputs: Directory_Api_Reference_Envelope_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every REST response uses the same envelope. Branch on data.error, never on message.`)
};

const zh_directory_api_reference_envelope_help = /** @type {(inputs: Directory_Api_Reference_Envelope_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有 REST 响应使用同一信封；按 data.error 分支判断，永远不要依赖 message。`)
};

/**
* | output |
* | --- |
* | "Every REST response uses the same envelope. Branch on data.error, never on message." |
*
* @param {Directory_Api_Reference_Envelope_HelpInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_api_reference_envelope_help = /** @type {((inputs?: Directory_Api_Reference_Envelope_HelpInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Api_Reference_Envelope_HelpInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_api_reference_envelope_help(inputs)
	return zh_directory_api_reference_envelope_help(inputs)
});
export { directory_api_reference_envelope_help as "directory.api_reference.envelope_help" }